import { http, http_main } from '@/environment/environment';
import { Game } from '@/_models/Game';
import { Helper } from "@/utils/Helper";

class GameService
{
    createGame(userId: string, jwtToken: string, data: any): Promise<any> {
        http.defaults.headers.common['Authorization'] = 'Bearer ' + jwtToken;
        return http.post(`games?userId=${userId}`, data);
    }

    updateGameDetails(gameName: string, userId: string, jwtToken: string, data: any): Promise<any> {
        http.defaults.headers.common['Authorization'] = jwtToken;
        return http.patch(`games/${gameName}?userId=${userId}`, data);
    }

    getGame(gameId: string): Promise<any> {
        return http.get(`games/${gameId}`);
    }

    getGameListByWalletAddress(walletAddress: string, network: string): Promise<any> {
        if(network=='testnet' || network=='all'){
            return http.get(`wallets/${walletAddress}/games`);
        }else{
            return http_main.get(`wallets/${walletAddress}/games`);
        }
    }

    getNamespaceList(walletAddress: string): Promise<any> {
        return http.get(`wallets/${walletAddress}/namespaces?ignoreLinked=true`);
    }

    getAttachedTokensToGame(gameId: string): Promise<any> {
        return http.get(`games/${gameId}/attach`);
    }

    getGameListByWalletAddressWithPagination(walletAddress: string, skip: number, limit: number, network: string): Promise<any> {
        if(network=='testnet'){
            return http.get(`wallets/${walletAddress}/games?skip=${skip}&limit=${limit}`);
        }else{
            return http_main.get(`wallets/${walletAddress}/games?skip=${skip}&limit=${limit}`);
        }
    }

    getInvitedGamers(gameId: string, userId: string, jwtToken: string, network: string): Promise<any> {
        if(network == 'testnet'){
            http.defaults.headers.common['Authorization'] = jwtToken;
            return http.get(`games/${gameId}/invites?userId=${userId}`);
        }else{
            http_main.defaults.headers.common['Authorization'] = jwtToken;
            return http_main.get(`games/${gameId}/invites?userId=${userId}`);
        }
    }

    inviteGamers(gameId: string, userId: string, jwtToken: string, emails: Array<string>): Promise<any> {
        http.defaults.headers.common['Authorization'] = jwtToken;
        let inviteGamersAPI = `games/${gameId}/invites?userId=${userId}`;

        for (let x = 0; x < emails.length; x++) {
            inviteGamersAPI = inviteGamersAPI.concat('&email=' + emails[x]);
        }

        return http.put(inviteGamersAPI);
    }

    updateGameGallery(gameId: string, userId: string, jwtToken: string, data: any): Promise<any> {
        http.defaults.headers.common['Authorization'] = jwtToken;

        return http.patch(`games/${gameId}/gallery?userId=${userId}`, data);
    }

    removeGameGallery(gameId: string, userId: string, jwtToken: string, imageId: string): Promise<any> {
        http.defaults.headers.common['Authorization'] = jwtToken;
        return http.delete(`games/${gameId}/gallery?userId=${userId}&imageId=${imageId}`);
    }

    inviteMainnetGamers(gameId: string, userId: string, jwtToken: string, emails: Array<string>): Promise<any> {
        http_main.defaults.headers.common['Authorization'] = jwtToken;
        let inviteGamersAPI = `games/${gameId}/invites?userId=${userId}`;

        for (let x = 0; x < emails.length; x++) {
            inviteGamersAPI = inviteGamersAPI.concat('&email=' + emails[x]);
        }

        return http_main.put(inviteGamersAPI);
    }

    async getPublishedGame(gameId: string): Promise<Game> {
        try{
            const fetchGame = await http.get(`games/${gameId}/publish`);
            return fetchGame.data;
        }catch(err){
            Helper.endpointErrorHandling(err);
        }
    }

    async linkedNamespaceToGameMainnet(gameId: string, namespaceName:string, userId: string, jwtToken: string): Promise<string> {
        try{
            http_main.defaults.headers.common['Authorization'] = jwtToken;
            const importNs = await http_main.put(`mainnet/game/${gameId}/namespace/import?userId=${userId}&namespaceName=${namespaceName}`);
            if(importNs.data.success){
                return importNs.data.message;
            }
        }catch(err){
            Helper.endpointErrorHandling(err);
        }
    }
}

export default new GameService();